let TradeKindEnum = {
  'SMALLMICRO' : 'smallmicro',
}

export default TradeKindEnum
